export const WEBSITE_SECTIONS = [
  {
    id: 'hero',
    section_id: 'hero',
    title: 'Hero Section',
    description: 'Main landing section',
    is_active: true,
    order_index: 1,
    children: [
      {
        id: 'hero-main',
        title: 'Hero Main Content',
        description: 'Main content for the hero section including headings and CTAs',
      },
      {
        id: 'hero-rotating-texts',
        title: 'Hero Rotating Texts',
        description: 'Rotating text elements in the hero section',
      },
      {
        id: 'hero-background-images',
        title: 'Hero Background Images',
        description: 'Background image carousel for hero section',
      },
      {
        id: 'hero-config',
        title: 'Hero Configuration',
        description: 'Configuration settings for the hero section',
      }
    ]
  },
  {
    id: 'platform-explorer',
    section_id: 'platform-explorer',
    title: 'Platform Explorer',
    description: 'Interactive platform showcase',
    is_active: true,
    order_index: 2
  },
  {
    id: 'social-proof',
    section_id: 'social-proof',
    title: 'Social Proof',
    description: 'Statistics and testimonials',
    is_active: false,
    order_index: 3
  },
  {
    id: 'comprehensive-solutions',
    section_id: 'comprehensive-solutions',
    title: 'Comprehensive Solutions',
    description: 'Complete platform features',
    is_active: true,
    order_index: 4
  },
  {
    id: 'feature-showcase',
    section_id: 'feature-showcase',
    title: 'Feature Showcase',
    description: 'Detailed feature presentation',
    is_active: true,
    order_index: 5
  },
  {
    id: 'client-staff-management',
    section_id: 'client-staff-management',
    title: 'Client & Staff Management',
    description: 'Management tools overview',
    is_active: true,
    order_index: 6
  },
  {
    id: 'newsletter',
    section_id: 'newsletter',
    title: 'Newsletter',
    description: 'Email subscription section',
    is_active: true,
    order_index: 7
  },
  {
    id: 'footer',
    section_id: 'footer',
    title: 'Footer',
    description: 'Page footer with links and info',
    is_active: true,
    order_index: 8
  }
];

